import { PATHS } from './navigateRoutes';

export const DASHBOARD_ANALYTICS_EVENTS = {
  navigationClick: 'dashboard_navigation_click',
  activationStepClick: 'activation_step_click',
  activationDocsClick: 'activation_docs_click',
  activationSupportClick: 'activation_support_click',
  activationPrimaryCtaClick: 'activation_primary_cta_click',
  memoryTabSelected: 'memory_tab_selected',
  memorySearchOpened: 'memory_search_opened',
  spaceSetupCtaClicked: 'space_setup_cta_clicked',
  spaceOpened: 'space_opened',
  spaceSettingUpdated: 'space_setting_updated',
  reportGroupCreateInitiated: 'report_group_create_initiated',
  reportGroupCreated: 'report_group_created',
  taskCreated: 'task_created',
} as const;

export type DashboardAnalyticsEvent =
  (typeof DASHBOARD_ANALYTICS_EVENTS)[keyof typeof DASHBOARD_ANALYTICS_EVENTS];

const DASHBOARD_ROUTE_MATCHERS: Array<{
  routeName: string;
  matches: (pathname: string) => boolean;
}> = [
  {
    routeName: 'get_started',
    matches: (pathname) => pathname === PATHS.getStarted,
  },
  { routeName: 'overview', matches: (pathname) => pathname === PATHS.overview },
  {
    routeName: 'whats_happening',
    matches: (pathname) => pathname === PATHS.whatsHappening,
  },
  {
    routeName: 'meeting_overview',
    matches: (pathname) => pathname === PATHS.meetingOverview,
  },
  { routeName: 'spaces', matches: (pathname) => pathname === PATHS.spaces },
  {
    routeName: 'report_groups',
    matches: (pathname) => pathname.startsWith(PATHS.reportGroups),
  },
  {
    routeName: 'connectors',
    matches: (pathname) => pathname.startsWith(PATHS.connectors),
  },
  {
    routeName: 'memory',
    matches: (pathname) => pathname.startsWith(PATHS.memory),
  },
  {
    routeName: 'settings',
    matches: (pathname) => pathname.startsWith(PATHS.settings),
  },
  { routeName: 'tasks', matches: (pathname) => pathname === PATHS.tasks },
  {
    routeName: 'sprints',
    matches: (pathname) => pathname.startsWith(PATHS.sprints),
  },
  {
    routeName: 'pricing_plans',
    matches: (pathname) => pathname === PATHS.pricingPlans,
  },
  { routeName: 'help', matches: (pathname) => pathname === PATHS.help },
  { routeName: 'users', matches: (pathname) => pathname === PATHS.users },
  {
    routeName: 'saved_prompts',
    matches: (pathname) => pathname === PATHS.savedPrompts,
  },
  { routeName: 'tags', matches: (pathname) => pathname === PATHS.tags },
  {
    routeName: 'invocation_history',
    matches: (pathname) => pathname.startsWith(PATHS.invocationHistory),
  },
  {
    routeName: 'polls',
    matches: (pathname) => pathname === PATHS.polls,
  },
];

export const getDashboardRouteName = (pathname: string): string => {
  return (
    DASHBOARD_ROUTE_MATCHERS.find((matcher) => matcher.matches(pathname))
      ?.routeName ?? 'unknown'
  );
};
